export default "__VITE_ASSET__D4ruRZ9J__"